import { render, staticRenderFns } from "./samples.vue?vue&type=template&id=1c12a51c&"
import script from "./samples.vue?vue&type=script&lang=js&"
export * from "./samples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports